import { Stack, Tooltip } from '@mui/material';

export type DateStatusBarProps = {
  period: string;
  count: number;
  percentage: number;
  color: string;
  label: string;
};

export function DateStatusBar({
  period,
  count,
  percentage,
  color,
  label,
}: DateStatusBarProps) {
  return (
    <Tooltip title={`${count} ${label} (${percentage.toFixed(0)}%)`}>
      <Stack
        className="h-8 rounded-sm transition-all hover:opacity-80"
        sx={{
          width: `${percentage}%`,
          backgroundColor: color,
        }}
      />
    </Tooltip>
  );
}
